import * as SlideToggle from 'slidetoggle';
import {createFocusTrap} from 'focus-trap';
import Cookies from 'js-cookie';

import '../css/main.css';

const headerGroupSelectors = [
  'promo-section',
  'header-top-section',
  'header-section',
];

/**
 * Promotional Section
 */
class PromoSection extends HTMLElement {
  constructor() {
    super();
    
    this.sticky = JSON.parse(this.dataset.sticky);
    this.announcementBars = this.querySelectorAll('[data-block-type="announcement-bar"]');

    if (this.announcementBars.length > 0) {
      this.initAnnoucementBars();
    }

    if (this.sticky) {
      this.setResizeObserver();
      this.setTopPosition();
    }

    this.bindEvents();
  }

  setTopPosition() {
    // Get all elements from headerGroupSelectors
    const headerGroups = document.querySelectorAll(
      headerGroupSelectors.join(',')
    );

    // Return where this element is in the index of headerGroups
    const headerGroupIndex = Array.prototype.indexOf.call(
      headerGroups,
      this
    );

    // Return elements in headerGroups before this element
    const headerGroupsBefore = Array.prototype.slice.call(
      headerGroups,
      0,
      headerGroupIndex
    );
    let top = 0;
    let calc = [];
    headerGroupsBefore.forEach((headerGroup) => {
      const cssVar = headerGroup.dataset.heightCssVar;
      if (cssVar) {
        calc.push(`var(${cssVar})`);
      }
    });
    if (calc.length) {
      top = `calc(${calc.join(' + ')})`;
    }
    this.parentElement.style.top = top;
  }

  setResizeObserver() {
    // create and dispatch the event
    const event = new CustomEvent('stickyResize', {
      detail: {
        element: this,
      },
    });

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.contentRect.height;
        document.documentElement.style.setProperty(
          '--promo-section-height',
          `${height}px`
        );
      }
    });

    resizeObserver.observe(this);
  }

  initAnnoucementBars() {
    this.announcementBars.forEach((bar) => {
      const hideDelay = JSON.parse(bar.dataset.hideDelay);
      if (!hideDelay || Shopify.designMode) return;

      setTimeout(() => {
        SlideToggle.hide(bar, {
          miliseconds: 300,
          transitionFunction: 'ease-out',
        });
      }, hideDelay);

    });
  }

  bindEvents() {
    const signupBars = this.querySelectorAll('[data-block-type="signup-bar"]');
    if (signupBars.length > 0) {
      signupBars.forEach((bar) => {
        const blockType = bar.dataset.blockType;
        const blockId = bar.dataset.blockId;
        const button = bar.querySelector('.signup-bar__close');
        const form = bar.querySelector('form');
        const showFor = bar.dataset.showFor;

        const showDelay = bar.dataset.delay;

        if (Shopify.designMode) {
          return;
        }

        // Uncomment to test 
        // Cookies.remove(`${blockType}-${blockId}`);

        // Show if Cookie doesn't exist
        if (Cookies.get(`${blockType}-${blockId}`) === undefined) {
          setTimeout(() => {
            if (
              showFor === 'desktop' &&
              window.innerWidth < theme.mobileBreakpoint
            ) {
              return;
            }
            if (
              showFor === 'mobile' &&
              window.innerWidth >= theme.mobileBreakpoint
            ) {
              return;
            }

            SlideToggle.toggle(bar, {
              miliseconds: 300,
              transitionFunction: 'ease-out',
            });
          }, showDelay);
        }

        button.addEventListener('click', (event) => {
          SlideToggle.toggle(bar, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });

          const expireDays = 60;
          Cookies.set(`${blockType}-${blockId}`, 'close', {
            expires: expireDays,
          });

          event.preventDefault();
        });

        if (this.form) {
          form.addEventListener('submit', (event) => {
            SlideToggle.toggle(bar, {
              miliseconds: 300,
              transitionFunction: 'ease-out',
            });

            const expireDays = 365;
            Cookies.set(`${blockType}-${blockId}`, 'submit', {
              expires: expireDays,
            });
          });
        }
      });
    }


    if (Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (!selectedBlock) return;

        if (selectedBlock.dataset.blockType === 'signup-bar') { 
          SlideToggle.show(selectedBlock, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });
        }

        if (selectedBlock.dataset.blockType === 'popup') {
          selectedBlock.showModal();
        }
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (!selectedBlock) return;

        if (selectedBlock.dataset.blockType === 'signup-bar') {
          SlideToggle.hide(selectedBlock, {
            miliseconds: 300,
            transitionFunction: 'ease-out',
          });
        }

        if (selectedBlock.dataset.blockType === 'popup') {
          selectedBlock.hideModal();
        }
      });
    }
    
  }
}
customElements.define('promo-section', PromoSection);

class PopupModal extends HTMLElement {
  constructor() {
    super();

    this.originalZIndex = 500;
    this.openZIndex = 1000;
    this.promoSection = this.closest('.section__promos');
    this.blockType = this.dataset.blockType;
    this.blockId = this.dataset.blockId;

    this.focusTrap = createFocusTrap(this, {
      initialFocus: false,
    });

    this.delay = this.dataset.delay;
    // True - only show to theme.pageType == index
    this.homepageLimit = JSON.parse(this.dataset.homepageLimit);
    // True - only show to theme.customers / False show to everyone
    this.visitorLimit = JSON.parse(this.dataset.visitorLimit);
    // mobile, desktop, both
    this.showFor = this.dataset.showFor;

    // Qualify if popup should be show
    if (Shopify.designMode) {
      return;
    }

    // Uncomment to test
    // Cookies.remove(`${this.blockType}-${this.blockId}`);
    
    // Don't show if cookied
    if (Cookies.get(`${this.blockType}-${this.blockId}`) !== undefined) {
      return;
    }

    if (this.homepageLimit == true && theme.pageType !== 'index') {
      return;
    }

    if (this.visitorLimit == true && theme.customer) {
      return;
    }

    setTimeout(() => {
      if (
        this.showFor === 'desktop' &&
        window.innerWidth < theme.mobileBreakpoint
      ) {
        return;
      }
      if (
        this.showFor === 'mobile' &&
        window.innerWidth >= theme.mobileBreakpoint
      ) {
        return;
      }

      this.bindEvents();
      this.showModal();
    }, this.delay);
  }

  bindEvents() {
    this.closeButton = this.querySelector('.modal__close');
    this.modalBackground = this.querySelector('.modal__background');
    this.form = this.querySelector('form');

    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.hideModal();

      const expireDays = 60;
      Cookies.set(`${this.blockType}-${this.blockId}`, 'close', {
        expires: expireDays,
      });
    });

    this.modalBackground.addEventListener('click', (event) => {
      event.preventDefault();
      this.hideModal();

      const expireDays = 60;
      Cookies.set(`${this.blockType}-${this.blockId}`, 'close', {
        expires: expireDays,
      });
    });

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hideModal();

      const expireDays = 60;
      Cookies.set(`${this.blockType}-${this.blockId}`, 'close', {
        expires: expireDays,
      });
    });
    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        const expireDays = 365;
        Cookies.set(`${this.blockType}-${this.blockId}`, 'submit', {
          expires: expireDays,
        });
      });
    }    
  }

  showModal() {
    document.body.classList.add('has-modal');
    this.promoSection.style.zIndex = this.openZIndex;
    this.classList.add('modal--active');
    this.closeButton = this.querySelector('.modal__close');
    this.closeButton.focus();

    this.focusTrap.activate();
  }

  hideModal() {
    document.body.classList.remove('has-modal');
    this.classList.remove('modal--active');

    this.focusTrap.deactivate();
  }
}
customElements.define('popup-modal', PopupModal);

/**
 * Top Header
 */
class HeaderTop extends HTMLElement {
  constructor() {
    super();

    this.menuButton = this.querySelector('.header-top__menu');
    this.menuDrawer = this.querySelector('menu-drawer');
    this.modalBackground = this.querySelector('.modal__background');
    this.modalClose = this.querySelector('.modal__close');

    this.headerTop = this.querySelector('.header-top');
    this.sticky = JSON.parse(this.headerTop.dataset.sticky);

    this.focusTrap = createFocusTrap(this.menuDrawer, {
      initialFocus: false,
    });

    if (this.sticky) {
      this.setResizeObserver();
      this.setTopPosition();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.menuButton.addEventListener('click', (event) => this.openMenu(event) );

    this.modalBackground.addEventListener('click', (event) =>
      this.closeMenu(event)
    );
    this.modalClose.addEventListener('click', (event) => this.closeMenu(event));
    this.addEventListener('keyup', (event) => this.menuKeyUp(event));
  }

  setTopPosition() {
    // Get all elements from headerGroupSelectors
    const headerGroups = document.querySelectorAll(
      headerGroupSelectors.join(',')
    );

    // Return where this element is in the index of headerGroups
    const headerGroupIndex = Array.prototype.indexOf.call(
      headerGroups,
      this
    );

    // Return elements in headerGroups before this element
    const headerGroupsBefore = Array.prototype.slice.call(
      headerGroups,
      0,
      headerGroupIndex
    );
    let top = 0;
    let calc = [];
    headerGroupsBefore.forEach((headerGroup) => {
      const cssVar = headerGroup.dataset.heightCssVar;
      if (cssVar) {
        calc.push(`var(${cssVar})`);
      }
    });
    if (calc.length) {
      top = `calc(${calc.join(' + ')})`;
    }
    this.parentElement.style.top = top;
  }

  setResizeObserver() {    
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.contentRect.height;
        document.documentElement.style.setProperty(
          '--header-top-section-height',
          `${height}px`
        );
      }
    });

    resizeObserver.observe(this);
  }

  openMenu(event) { 
    event.preventDefault();

    this.parentElement.style.zIndex = 1000;

    this.menuButton.setAttribute('aria-expanded', true);
    this.menuDrawer.setAttribute('open', true);
    document.body.classList.add('has-modal');

    this.focusTrap.activate();
  }

  menuKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeMenu(event);
  }

  closeMenu(event) {
    event.preventDefault();

    this.parentElement.style.zIndex = '';

    this.menuButton.setAttribute('aria-expanded', false);
    this.menuDrawer.removeAttribute('open');
    document.body.classList.remove('has-modal');

    this.focusTrap.deactivate();
  }
}
customElements.define('header-top-section', HeaderTop);

class Header extends HTMLElement {
  constructor() {
    super();

    this.headerWrapper = this.querySelector('.header-wrapper');
    this.sticky = JSON.parse(this.headerWrapper.dataset.sticky);

    if (this.sticky) {
      this.setResizeObserver();
      this.setTopPosition();
    }

    this.menuButton = this.querySelector('button[data-menu-drawer-button]');
    if(!this.menuButton) return;

    const topHeader = document.querySelector('header-top-section');
    if (topHeader) {
      this.menuDrawer = topHeader.querySelector('menu-drawer');

      this.menuButton.addEventListener('click', (event) => {
        event.preventDefault();
        topHeader.openMenu(event);
      });

    } else {
      this.menuDrawer = this.querySelector('menu-drawer');
      this.modalBackground = this.querySelector('.modal__background');
      this.modalClose = this.querySelector('.modal__close');

      this.focusTrap = createFocusTrap(this.menuDrawer, {
        initialFocus: false,
      });

      this.bindEvents();
    }
  }

  setTopPosition() {
    // Get all elements from headerGroupSelectors
    const headerGroups = document.querySelectorAll(
      headerGroupSelectors.join(',')
    );

    // Return where this element is in the index of headerGroups
    const headerGroupIndex = Array.prototype.indexOf.call(
      headerGroups,
      this
    );

    // Return elements in headerGroups before this element
    const headerGroupsBefore = Array.prototype.slice.call(
      headerGroups,
      0,
      headerGroupIndex
    );
    let top = 0;
    let calc = [];
    headerGroupsBefore.forEach((headerGroup) => {
      const cssVar = headerGroup.dataset.heightCssVar;
      if (cssVar) {
        calc.push(`var(${cssVar})`);
      }
    });
    if (calc.length) {
      top = `calc(${calc.join(' + ')})`;
    }
    this.parentElement.style.top = top;
  }

  setResizeObserver() {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.contentRect.height;

        document.documentElement.style.setProperty(
          '--header-section-height',
          `${height}px`
        );
      }
    });

    resizeObserver.observe(this);
  }

  bindEvents() {
    this.menuButton.addEventListener('click', (event) => this.openMenu(event) );

    this.modalBackground.addEventListener('click', (event) =>
      this.closeMenu(event)
    );
    this.modalClose.addEventListener('click', (event) => this.closeMenu(event));
    this.addEventListener('keyup', (event) => this.menuKeyUp(event));
  }

  openMenu(event) {
    event.preventDefault();

    this.parentElement.style.zIndex = 1000;

    this.menuButton.setAttribute('aria-expanded', true);
    this.menuDrawer.setAttribute('open', true);
    document.body.classList.add('has-modal');

    this.focusTrap.activate();
  }

  menuKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeMenu(event);
  }

  closeMenu(event) {
    event.preventDefault();

    this.parentElement.style.zIndex = '';

    this.menuButton.setAttribute('aria-expanded', false);
    this.menuDrawer.removeAttribute('open');
    document.body.classList.remove('has-modal');

    this.focusTrap.deactivate();
  }
}
customElements.define('header-section', Header);


class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    const isEnabled = JSON.parse(this.dataset.enabled);

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.ModalPredictiveSearch = this.closest('modal-predictive-search')
    this.closeButton = this.querySelector('.search-bar__close');
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');

    this.cachedResults = {};
    this.searchTerm = '';
    this.abortController = new AbortController();

    // Event listeners
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.close(true);

      if (this.ModalPredictiveSearch) {
        this.ModalPredictiveSearch.closeModal();
      }
    });

    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));

    // At this point return to block all other functionality if not enabled
    if (!isEnabled) return;

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.input.form.addEventListener('submit', this.onSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onFocus() {
    const currentSearchTerm = this.input.value.trim();

    if (!currentSearchTerm.length) return;

    if(this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }

    const searchLength = currentSearchTerm.length;
    this.input.setSelectionRange(searchLength, searchLength);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  onKeyup(event) {
    // If the input is empty close
    // if (!this.input.value.trim().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'Enter':
        this.selectOption();
        break;
      case 'Escape':
        this.close(true, 'escape');
        break;
    }
  }

  onKeydown(event) {
    if (
      event.code === 'ArrowDown' ||
      event.code === 'ArrowUp'
    ) {
      event.preventDefault();
    }
  }

  onChange() {
    const newSearchTerm = this.input.value.trim();

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Clear out the search terms
      this.querySelector('#predictive-search-results-wrapper')?.remove();
    }

    this.searchTerm = newSearchTerm;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onSubmit(event) {
    // Don't submit the form if the input is empty or if any elements have aria-selected="true"
    if (this.input.value.trim().length === 0) {
      event.preventDefault();
      return;
    }

    // submit the form 
    this.input.form.submit();
    
    this.selectOption();
  }    

  getSearchResults(searchTerm) { 
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      {signal: this.abortController.signal}
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsHtml = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#predictive-search-results-wrapper').innerHTML;
        // Cache the results
        this.cachedResults[queryKey] = resultsHtml;

        this.renderSearchResults(resultsHtml);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsHtml) {
    this.predictiveSearchResults.innerHTML = resultsHtml;

    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  close(clearSearchTerm = false, type = '') {
    // Check if input is aria-expanded true
    if (
      this.input.getAttribute('aria-expanded') === 'false' &&
      this.ModalPredictiveSearch &&
      type === 'escape'
    ) {
      this.ModalPredictiveSearch.closeModal()
      return;
    }

    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);

    this.isOpen = false;
    this.predictiveSearchResults.style.display = 'none';
  }

  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    this.predictiveSearchResults.style.display = 'block';
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;
    
    const focusUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allFocusElements = Array.from(this.querySelectorAll('[role="option"]')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = allFocusElements.indexOf(selectedElement);

    // TODO: Status element for live region

    if (!focusUp && selectedElement) {
      // Go to next element in the list and loop back to the first if at the end
      activeElementIndex = (activeElementIndex + 1) % allFocusElements.length;
    } else if (focusUp) {
      // Go to the previous element in the list and loop back to the last if at the beginning
      activeElementIndex =
        (activeElementIndex - 1 + allFocusElements.length) %
        allFocusElements.length;
    }
    const activeElement = allFocusElements[activeElementIndex];
    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {

    const selectedElement = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    if (selectedElement) {
      selectedElement.click();
    }
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);

class ModalPredictiveSearch extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.searchButtons = document.querySelectorAll(
      'button[aria-controls="ModalPredictiveSearch"]'
    );
    this.overlay = this.querySelector('.predictive__overlay');

    // Events
    this.searchButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.activeSearchButton = event.target;
        this.openModal()
      });
    });
    this.overlay.addEventListener('click', () => this.closeModal() );
    
    this.focusTrap = createFocusTrap(this, {
      initialFocus: false,
      escapeDeactivates: false,
    }); 
  }

  openModal() {
    this.setAttribute('aria-modal', 'true');

    this.focusTrap.activate();

    const predictiveInput = this.querySelector('.predictive__input');
    if (predictiveInput) predictiveInput.focus();
  }

  closeModal() {
    this.setAttribute('aria-modal', 'false');
    this.focusTrap.deactivate();
  }
}
customElements.define('modal-predictive-search', ModalPredictiveSearch);


/**
 * Disclosure Localization
 */
class DisclosureItem extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.panel = this.querySelector('ul.disclosure__list');

    this.button.addEventListener('click', (event) => this.openPanel(event));
    this.addEventListener('focusout', (event) => this.panelFocusCheck(event));
    this.addEventListener('keyup', (event) => this.panelKeyUp(event));
  }

  openPanel(event) {
    event.preventDefault();
    this.button.focus();
    this.panel.toggleAttribute('hidden');
    this.button.setAttribute(
      'aria-expanded',
      (this.button.getAttribute('aria-expanded') === 'false').toString()
    );
  }

  panelFocusCheck(event) {
    if (event.relatedTarget === null || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }

  panelKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.button.focus();
  }

  hidePanel() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', true);
  }
}
customElements.define('disclosure-item', DisclosureItem);

class DisclosureForm extends DisclosureItem {
  constructor() {
    super();

    this.input = this.querySelector(
      'input[name="locale_code"], input[name="country_code"]'
    );
    this.form = this.querySelector('form');
    this.querySelectorAll('a').forEach((item) =>
      item.addEventListener('click', (event) => this.onItemClick(event))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    this.input.value = event.currentTarget.dataset.value;
    if (this.form) {
      this.form.submit();
    }
  }
}
customElements.define('disclosure-form', DisclosureForm);

class DisclosureMenu extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.detailsChildren = this.querySelectorAll(
      'details .list-menu:not([data-mega-menu]) details'
    );
    this.summary = this.querySelector('summary');

    this.details.addEventListener('click', (event) => this.onOpenPanel(event));
    this.addEventListener('keyup', (event) => this.panelKeyUp(event));
    
    if (this.details.classList.contains('header-menu__details')) {
      this.addEventListener('focusout', (event) => this.panelFocusCheck(event));
      this.addEventListener('pointerenter', (event) => this.panelMouseEnter(event));
      this.addEventListener('pointerleave', (event) => this.panelMouseLeave(event));
    }

    this.nav = this.closest('nav');
  }

  onOpenPanel(event) {
    const currentDetails = event.target.closest('details');
    this.detailsChildren.forEach((item) => {
      if (item == currentDetails) return;
      this.hidePanel(item);
    });

    if (this.nav) {
      const drawerSiblingDetails = this.nav.querySelectorAll(
        'details.drawer-menu__details'
      );
      drawerSiblingDetails.forEach((item) => {
        if (
          item === currentDetails ||
          currentDetails.classList.contains('drawer-menu__details-child')
        )
          return;

        this.hidePanel(item);
      });

      const autoClosingDetails = this.nav.querySelectorAll(
        'details.footer-menu__details, details.menu__details'
      );
      autoClosingDetails.forEach((item) => {
        if (
          item === currentDetails ||
          currentDetails.classList.contains('footer-menu__details-child') ||
          currentDetails.classList.contains('menu__details-child')
        )
          return;

        this.hidePanel(item);
      });
    }

    window.theme.isMouseDevice = this.checkDeviceType(event);    

    if (event.type === 'click' && event.detail > 0) {
      if (
        window.theme.isMouseDevice &&
        currentDetails.classList.contains('header-menu__details')
      ) {
        window.location.href = currentDetails.dataset.link;
      }
    }
  }

  checkDeviceType(event) {
    let isMouseDevice = false;
    if (event.type === 'mouseenter' || event.pointerType === 'mouse') {
      isMouseDevice = true;
    }

    return isMouseDevice;
  }

  panelMouseEnter(event) {
    if (event.pointerType === 'mouse') {
      this.openPanel(this.details);
      this.onOpenPanel(event);
    }
  }
  panelMouseLeave(event) {
    if (event.pointerType === 'mouse') {
      this.hidePanel(this.details);
    }
  }

  panelFocusCheck(event) {
    if (event.relatedTarget === null || !this.contains(event.relatedTarget)) {
      this.hidePanel(this.details);
    }
  }
 
  panelKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const closestDetails = document.activeElement.closest('details');
    const closestSummary = closestDetails.querySelector('summary');

    this.hidePanel(closestDetails);
    closestSummary.focus();
  }

  openPanel(details) {
    details.setAttribute('open', true);

    const panelContent = details.querySelector('[data-accordion-panel]');
    if (panelContent) {
      panelContent.style.right = 'auto';

      // Check if any part of the element is off the screen
      const rect = panelContent.getBoundingClientRect();

      // If right side is out of the viewport set right to 0px
      if (rect.right > (window.innerWidth || document.documentElement.clientWidth)) {
        panelContent.style.right = '0px';
      }
    }    
  }

  hidePanel(details) {
    details.removeAttribute('open');
  }
}
customElements.define('disclosure-menu', DisclosureMenu);

/**
 * Swatch - Radios
 */
class SwatchRadios extends HTMLElement {
  constructor() {
    super();

    this.productCard = this.closest('product-card');
    this.productMedia = this.productCard.querySelector('.product-card__link');
    this.productImage = this.productCard.querySelector(
      '.product-card__featured-image'
    );
    this.productLink = this.productCard.querySelector('.product-card__link');

    this.addEventListener('change', this.onSwatchChange);
  }

  onSwatchChange(event) {
    this.selected = event.target;
    this.selectedVariantUrl = this.selected.dataset.variantUrl;
    this.selectedVariantImage = this.selected.dataset.variantImage;

    if (this.selectedVariantImage) {
      this.updateImage();
    }
    this.updateLinks();
  }

  updateImage() {
    this.productImage.src = this.selectedVariantImage;
    this.productImage.srcset = '';
    this.productImage.sizes = '';
  }

  updateLinks() {
    this.productMedia.setAttribute('href', this.selectedVariantUrl);
  }
}
customElements.define('swatch-radios', SwatchRadios);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.link = this.querySelector('.product-card__link');
    console.log('this.link', this.link);

    this.touchStartX = null;
    this.touchStartY = null;

    this.link.addEventListener('touchstart', this.handleTouchStart);
    this.link.addEventListener('touchend', this.handleTouchEnd);
    this.link.addEventListener('mousedown', this.handleClick);
  }

  handleTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
  }

  handleTouchEnd(event) {
    const touchEndX = event.changedTouches[0].clientX;
    const touchEndY = event.changedTouches[0].clientY;
    const distanceX = Math.abs(touchEndX - this.touchStartX);
    const distanceY = Math.abs(touchEndY - this.touchStartY);

    const threshold = 10; // Adjust this value based on your requirements

    // If the touch didn't move significantly, treat it as a tap.
    if (distanceX < threshold && distanceY < threshold) {
      event.preventDefault();
      // Navigate to the link's destination.
      window.location.href = this.href;
    }
  }

  handleClick(event) {
    if (event.type === 'mousedown') return;
  }
}
customElements.define('product-card', ProductCard);

/**
 * Quantity Select
 */
class QuantitySelect extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.quantity__input');
    this.minus = this.querySelector('.quantity__button[name="minus"]');
    this.plus = this.querySelector('.quantity__button[name="plus"]');

    this.changeEvent = new Event('change', {bubbles: true});

    this.minus.addEventListener('click', (event) => {
      this.decreaseQuantity();
    });
    this.plus.addEventListener('click', (event) => {
      this.increaseQuantity();
    });
  }

  decreaseQuantity(event) {
    const previousValue = this.input.value;

    if (Number(this.input.value) == 1) return;
    this.input.value = Number(this.input.value) - 1;
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  increaseQuantity(event) {
    const previousValue = this.input.value;

    this.input.value = Number(this.input.value) + 1;
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-select', QuantitySelect);

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.cartButton = document.getElementById('cart-button');
    this.notification = this;
    this.sectionId = this.dataset.sectionId;
    this.continueButton = this.querySelector('.cart-notification__continue');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.focusTrap = createFocusTrap(this.notification, {
      allowOutsideClick: true,
    });
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        this.close();
      })
    });
  }

  open() {
    this.notification.classList.add('cart-notification--active');
    this.notification.focus();
    this.focusTrap.activate();
    document.body.addEventListener('click', this.onBodyClick);

    this.querySelector('.cart-notification__continue').addEventListener('click', (event) => {
      event.preventDefault();
      this.close();
    });
  }

  close() {
    this.notification.classList.remove('cart-notification--active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.focusTrap.deactivate();
    this.activeElement.focus();
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-links',
      },
      {
        id: 'cart-button',
      },
      {
        id: 'cart-icon-button',
      },
    ];
  }

  renderContents(response) {
    this.productId = response.id;
    this.getSectionsToRender().forEach((section) => {
      const elements = document.querySelectorAll(`#${section.id}`);
      if (!elements.length) return;

      elements.forEach((element) => {
        element.innerHTML = this.getSectionInnerHTML(
          response.sections[section.id],
          section.selector
        );
      });

      // document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
      //   response.sections[section.id],
      //   section.selector
      // );
    });

    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}
customElements.define('cart-notification', CartNotification);

/*
* Theme Common JS
*/

/**
 * Delay Javascript until user interaction
 * Sections will lazyload when in view, but some should wait until it is in view 
 * and the user has interacted with the page.
 */

theme.userInteraction = false;
const userInteractionEvents = ['mouseover', 'keydown', 'scroll', 'touchstart'];

document.addEventListener('DOMContentLoaded', () => {
  userInteractionEvents.forEach((eventName) => {
    document.addEventListener(eventName, onUserInteraction, {
      passive: true
    });
  });
});


function onUserInteraction() {
  theme.userInteraction = true;

  userInteractionEvents.forEach((event) => {
    document.removeEventListener(event, onUserInteraction, {
      passive: true
    });
  });
};

theme.isTouchDevice = () => {
  return (
    'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
  );
}

theme.debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

theme.fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

theme.pauseAllMedia = () => {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
